import * as React from 'react';
import { colors } from '../../../index';

const IconFilterResult = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 28 42",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.669 12.444H2.33A2.333 2.333 0 000 14.774v2.538c0 .558.2 1.097.562 1.517l8.21 9.579c.361.423.561.963.561 1.52v5.417c0 .507.25.983.665 1.27l6.234 4.332a1.55 1.55 0 002.435-1.275v-9.744c0-.557.2-1.096.561-1.519l8.21-9.579A2.33 2.33 0 0028 17.313v-2.539a2.333 2.333 0 00-2.331-2.33zm-7.621 14.953a3.873 3.873 0 00-.75 1.38h-2.52v1.556h2.333v1.556h-2.333v1.555h2.335L17.115 35h-1.56v1.556h1.562l.002 3.112-6.23-4.324v-5.417a3.89 3.89 0 00-.937-2.531l-7.482-8.73h23.06l-7.482 8.731zm8.396-11.063a.778.778 0 01-.777.777H2.335a.78.78 0 01-.78-.78v-1.557c0-.427.348-.774.775-.774h23.34c.428 0 .775.347.775.774v1.56zM6.221 10.11a2.333 2.333 0 110-4.667 2.333 2.333 0 010 4.667zm10.89-3.112a3.111 3.111 0 110-6.222 3.111 3.111 0 010 6.222zm7 5.446h-4.667c0-1.555 1.044-2.333 2.333-2.333 1.289 0 2.333.778 2.333 2.333z"
  }));
};

export default IconFilterResult;